<agm-map [latitude]="lat" [longitude]="long" [zoom]="zoom">
  <agm-marker [latitude]="lat" [longitude]="long"></agm-marker>
</agm-map>
